import { useQuery } from '@tanstack/react-query'
import { fetchMySessions } from './conversations-api'

export const useMyConversationSessions = (projectId: string) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['my-sessions', projectId],
    queryFn: () => fetchMySessions(projectId),
    select: (data) => ({ data: data.data.filter((session) => session.myStatus !== 'LEFT') }),
    enabled: !!projectId,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  })
  return { data: data?.data, isLoading: isLoading, error: error }
}
